import api from "../../../api/axios";

// Thin call-wrappers around /api/notifications/preferences/.
// GET returns the full NotificationPreferenceSerializer body; PATCH
// accepts a partial body and returns the updated full body. No
// normalisation here — the widget consumes the shapes directly.

export const fetchNotificationPreferences = () =>
  api.get("/notifications/preferences/").then((res) => res.data);

export const patchNotificationPreferences = (partial) =>
  api
    .patch("/notifications/preferences/", partial)
    .then((res) => res.data);
